<ng-container *transloco="let t;">
<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{t('Modal title (custom columns modal) - Manage columns') }}</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<form>
    <div class="modal-body px-0" tabindex="0" ngbAutofocus>
        <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="customColumnsScrollDiv">
            <div class="">
                <div class="customColumnsWrapper px-2">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-lg-12">
                            <h6 class="mb-1">{{ t('Choose column section title (custom columns modal) - Add or remove columns') }}</h6>
                            <div class="d-flex align-content-center justify-content-between w-100 mb-1">
                                <div class="input-group input-group-merge">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i data-feather="search"></i></span>
                                    </div>
                                    <ng-autocomplete
                                            class="form-control CC_autoCompleteSearch px-0" #auto
                                            [data]="_searchedColumns"
                                            (inputChanged)="searchColumn($event)"
                                            (inputCleared)="clearSearch($event)"
                                            [searchKeyword]="_columnKeyWord"
                                            [placeholder]="t('Search column placeholder (custom columns modal) - Search columns')"
                                            (selected)='selectColumn($event);auto.clear()'
                                            [itemTemplate]="itemTemplate"
                                            [notFoundTemplate]="notFoundTemplate"
                                            [isLoading]="_customColumnSearchLoader">
                                    </ng-autocomplete>
                                    <ng-template #itemTemplate let-item>
                                        <a [innerHTML]="item.meta_data_name"></a>
                                    </ng-template>
                                    <ng-template #notFoundTemplate let-notFound>
                                        <div [innerHTML]="notFound"></div>
                                    </ng-template>
                                </div>
                            </div>
                            <div class="reoderedColumnsWrapper">
                                <div class="sortColumnWrapper" cdkDropList (cdkDropListDropped)="drop($event)">
                                    <ng-container *ngFor="let customColumn of customColumns; let i = index;">
                                        <div cdkDrag class="sortColumnList py-75" *ngIf="customColumn.status === 1">
                                            <div class="d-flex justify-content-between align-content-center">
                                                <div
                                                        class="sortColumnListText d-flex justify-content-start align-content-center">
                                                        <span placement="auto" [ngbTooltip]="t('Reorder columns section, sort tooltip (custom columns modal) - Sort')" container="body">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler manageColumnSortIcon icon-tabler-menu font-medium-1 me-50 cursor-row-resize" width="16" height="16" viewBox="0 0 24 24" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                                <path d="M4 8l16 0" />
                                                                <path d="M4 16l16 0" />
                                                            </svg>
                                                        </span>
                                                    <p class="mb-0">{{ t(customColumn.label) }}</p>
                                                </div>
                                                <div class="sortColumnListIcon">
                                                        <span placement="auto" triggers="hover" [ngbTooltip]="t('Reorder columns section, delete tooltip (custom columns modal) - delete')"
                                                              (click)="deleteColumn(customColumn, 0)">
                                                            <i data-feather="trash-2"
                                                               class="font-medium-1 cursor-pointer text-danger"></i>
                                                        </span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-scrollbar>

    </div>
    <div class="modal-footer">
        <button type="reset" class="btn btn-outline-secondary" (click)="modal.dismiss('Cross click')" rippleEffect>
            {{ t('Cancel button (custom columns modal) - Cancel') }}
        </button>
        <button type="submit" (click)="updateCustomColumnSettings()" class="btn btn-success" rippleEffect>
            {{ t('Update button (custom columns modal) - Update') }}
        </button>
    </div>
</form>
</ng-container>
